import styles from './SearchFeedback.scss';

export const SearchFeedback = ({query, count, clearFunction, loading = false}) => {
    if(query === ''){
        return null;
    }
    if(loading){
        return null;
    }
    return (
        <div className={styles.searchFeedback} data-cy="SearchFeedback">
            <div className={ styles.searchFeedback__background }>
                <div className={ styles.searchFeedback__layout }>
                    <p className={ styles.searchFeedback__resultsCaption }>
                        Found <span data-cy="SearchFeedback-count">{count}</span> results for '{query}'
                    </p>
                    <div className={ styles.searchFeedback__resultsControls }>
                        <span className={ styles.searchFeedback__labelButton } onClick={clearFunction}>Clear Your Results</span>
                        {/* <p className={ styles.searchFeedback__resultsInstructions }>or use 'Esc'</p> */}
                    </div>
                </div>
            </div>
        </div>
    );
};
